export const formatCurrency = (amount: string | number, currency = 'IDR'): string => {
  const num = typeof amount === 'string' ? parseFloat(amount) : amount;
  return new Intl.NumberFormat('id-ID', {
    style: 'currency', currency, minimumFractionDigits: 0, maximumFractionDigits: 0,
  }).format(num);
};

export const formatDate = (dateStr: string): string => {
  return new Date(dateStr).toLocaleDateString('id-ID', {
    day: 'numeric', month: 'short', year: 'numeric',
  });
};

export const formatDateTime = (dateStr: string): string => {
  return new Date(dateStr).toLocaleString('id-ID', {
    day: 'numeric', month: 'short', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
  });
};

export const statusColor = (status: string): string => {
  const map: Record<string, string> = {
    confirmed: '#3B6D11', pending: '#854F0B', cancelled: '#A32D2D',
    refunded: '#0C447C', expired: '#5F5E5A', aktif: '#3B6D11', baru: '#854F0B',
    settled: '#3B6D11', reversed: '#A32D2D',
  };
  return map[status] || '#5F5E5A';
};

export const statusBg = (status: string): string => {
  const map: Record<string, string> = {
    confirmed: '#EAF3DE', pending: '#FAEEDA', cancelled: '#FCEBEB',
    refunded: '#E6F1FB', expired: '#F1EFE8', aktif: '#EAF3DE', baru: '#FAEEDA',
    settled: '#EAF3DE', reversed: '#FCEBEB',
  };
  return map[status] || '#F1EFE8';
};
